module.exports = __webpack_public_path__ + "img/FR14318.e7e9e32e.png";